import { styled } from '@mui/material'

import type { FooterVariant } from './Footer.types'

export const StyledDiv = styled('div')`
  display: none;
  @media (min-width: ${({ theme }) => theme.breakpoints.values.sm}px) {
    position: relative;
    display: flex;
    align-items: center;
    margin-bottom: ${({ theme }) => theme.spacing(2)};
  }
`

export const GreyText = styled('span', {
  shouldForwardProp: (prop) => prop !== 'variant',
})<{ variant: FooterVariant }>(({ theme, variant }) => ({
  color: variant === 'light' ? theme.colours.new.grey7 : theme.colours.new.baseMidColour,
  fontSize: theme.typography.pxToRem(14),
}))

export const StyledIcon = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  paddingLeft: theme.spacing(1),
}))
